import React from "react";
import close from '../../assets/images/close.svg'
import down from "../../assets/images/icondropdown.svg";

const AddProduct = ({ productsList, setAddNewProduct, addNewProduct, reference, setOrder, productsToAdd, setProductsToAdd, productErrors, setProductErrors, errors, setErrors }) => {

    const addMoreProduct = () => {
        setProductsToAdd(prev => [...prev, { search: "", selectedProduct: null, openDropdown: false, qty: "", unit: "", unitCost: "", hsnCode: "", cgst: 0, sgst: 0, igst: 0, categoryName: '', productId: '', unit: "", unitPlural: "", }]);
    };

    const clearError = (index, key) => {
        setProductErrors(prev => {
            const newErr = [...prev];
            if (newErr[index]) {
                delete newErr[index][key];
            }
            return newErr;
        });
    };


    const updateProduct = (index, key, value) => {
        const newProducts = [...productsToAdd];
        newProducts[index][key] = value;
        setProductsToAdd(newProducts);
    };

    const handleSave = () => {
        let newErrors = [];

        productsToAdd.forEach((p, index) => {
            let err = {};

            if (!p.selectedProduct) {
                err.product = "Please select a product";
            }

            if (!p.qty || p.qty <= 0) {
                err.qty = "Quantity must be greater than 0";
            }

            newErrors[index] = err;
        });

        setProductErrors(newErrors);

        // If ANY error exists, stop save
        const hasError = newErrors.some(e => Object.keys(e).length > 0);
        if (hasError) return;

        // --- Save Logic ---
        const validProducts = productsToAdd.filter(p => p.selectedProduct !== null);

        setOrder(prevOrder => {
            const products = prevOrder?.products || [];
            const lastId =
                products.length > 0
                    ? Math.max(...products.map(p => p.id))
                    : 0;

            return {
                ...prevOrder,
                products: [
                    ...products,
                    ...validProducts.map((p, idx) => {
                        const unitCost = parseFloat(p?.unitCost) || 0;
                        const qty = p?.qty || 0;
                        const cgst = p?.cgst || 0;
                        const sgst = p?.sgst || 0;
                        const igst = p?.igst || 0;

                        const lineTotal = unitCost * qty;
                        const cgstAmount = (lineTotal * cgst) / 100;
                        const sgstAmount = (lineTotal * sgst) / 100;
                        const igstAmount = (lineTotal * igst) / 100;
                        const total = lineTotal + cgstAmount + sgstAmount + igstAmount;

                        return {
                            id: lastId + idx + 1,
                            item: p?.selectedProduct?.title,
                            hsnCode: p?.selectedProduct?.hsnCode || "",
                            quantity: qty,
                            unit: p?.unit,
                            unitCost: unitCost,
                            lineTotal: lineTotal,
                            cgst: cgst,
                            sgst: sgst,
                            igst: igst,
                            total: total,
                            productId: p?.selectedProduct?.productId || "",
                            categoryName: p?.selectedProduct?.level1CategoryName || "",
                            unit: p?.unit || "", 
                            unitPlural: p?.unitPlural || "",
                        };
                    })
                ]
            };
        });

        // Reset
        setProductsToAdd([{ search: "", selectedProduct: null, openDropdown: false, qty: "", unit: "", unitCost: "", hsnCode: "", cgst: 0, sgst: 0, igst: 0, categoryName: '' , productId: '', unit: "", unitPlural: "",}]);
        setErrors({ ...errors, products: '' });
        setAddNewProduct(false);
    };

    return (
        <>
            {
                addNewProduct &&
                <>
                    <div className="popup-overlay">
                    </div>
                    <div className="popup-box add-new-user" ref={reference}>
                        <div className="popupTop popupTopClose closePlan previewClose">
                            <img src={close} onClick={() => setAddNewProduct(false)} alt="Icon" />
                        </div>

                        <div className='popupModalTitle'>Add products</div>
                        {productsToAdd?.map((product, index) => {
                            const filtered = product.search.trim() === ""
                                ? productsList
                                : productsList.filter((p) =>
                                    p.title.toLowerCase().includes(product.search.toLowerCase())
                                );
                            return (
                                <div key={index} className={`product-add-dropdown-list ${productsToAdd?.length > 1 && 'add-border'} ${index > 0 && 'more-product'}`}>
                                    <div className="popup-form">
                                        <label>Product</label>
                                        <div className="dropdown-wrapper">
                                            {/* Header (just shows selected text) */}
                                            <div
                                                className="dropdown-header"
                                                onClick={() =>
                                                    updateProduct(index, "openDropdown", !product.openDropdown)
                                                }
                                            >
                                                <span>
                                                    {product?.selectedProduct ? product?.selectedProduct?.title : "Select product"}
                                                </span>
                                                <span className={`arrow ${product.openDropdown ? "rotate" : ""}`}>
                                                    <img src={down} alt="down-image"/>
                                                </span>
                                            </div>

                                            {productErrors[index]?.product && (
                                                <p className="error-message">{productErrors[index].product}</p>
                                            )}

                                            {/* Dropdown Panel */}
                                            {product.openDropdown && (
                                                <div className="dropdown-list">
                                                    <input
                                                        type="text"
                                                        className="dropdown-search"
                                                        placeholder="Search..."
                                                        value={product.search}
                                                        onChange={(e) => {
                                                            updateProduct(index, "search", e.target.value);
                                                        }}
                                                        autoFocus
                                                    />

                                                    {/* Search Results */}
                                                    {filtered.length === 0 ? (
                                                        <div className="dropdown-item empty">No product found</div>
                                                    ) : (
                                                        filtered.map((p) => (
                                                            <div
                                                                key={p.id}
                                                                className="dropdown-item"
                                                                onClick={() => {
                                                                    updateProduct(index, "selectedProduct", p);
                                                                    updateProduct(index, "search", "");
                                                                    updateProduct(index, "openDropdown", false);
                                                                    updateProduct(index, "unit", p?.unit);
                                                                    updateProduct(index, "unitCost", p?.priceFrom || "");
                                                                    updateProduct(index, "hsnCode", p?.hsnCode || "");
                                                                    updateProduct(index, "cgst", p?.tax?.cgst || 0);
                                                                    updateProduct(index, "sgst", p?.tax?.sgst || 0);
                                                                    updateProduct(index, "igst", p?.tax?.igst || 0);
                                                                    clearError(index, "product");
                                                                    clearError(index, "unitCost");
                                                                }}
                                                            >
                                                                {p.title}
                                                            </div>
                                                        ))
                                                    )}
                                                </div>
                                            )}
                                        </div>

                                    </div>
                                    <div className="form-group" >
                                        <label>Quantity</label>
                                        <input
                                            type="text"
                                            onWheel={(e) => e.target.blur()}
                                            value={product?.qty}
                                            placeholder="Add quantity"
                                            onChange={(e) => {
                                                const val = e.target.value || "";
                                                if (/^\d*\.?\d*$/.test(val)) {
                                                    updateProduct(index, 'qty', val);
                                                    clearError(index, "qty");
                                                }
                                            }}
                                            className="form-input"
                                        />
                                        {productErrors[index]?.qty && (
                                            <p className="error-message">{productErrors[index].qty}</p>
                                        )}

                                    </div>
                                </div>
                            );
                        })}
                        <div className="buttons">
                            <div className="popup-actions">
                                <button className="add-product-btn add-btn" onClick={addMoreProduct}>Add more product</button>
                                <button className="save-btn" onClick={handleSave}>Save</button>
                            </div>
                        </div>
                    </div>
                </>
            }
        </>

    );
};

export default AddProduct;
